import('./bootstrap');

if (process.env.NODE_ENV?.includes('prod') || !process.env.NODE_ENV) {
  console.log = () => {};
  console.info = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
}
